<template>
  <div class="primary-feature">
    <!--    头部 banner  和  主标题-->
    <div class="head">
      <!--      背景banner-->
      <img class="head-banner" src="./images/mathImages/banner.svg" />
    </div>

    <!--    计算题大通关-->
    <div id="div1" class="complete-calculation-problem">
      <div class="introduce">
        <div class="introduce-title">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="340"
            height="42"
            viewBox="0 0 340 42"
            fill="none"
          >
            <path
              d="M0 22C0 33.0457 8.9543 42 20 42H320C331.046 42 340 33.0457 340 22V0H0V22Z"
              fill="url(#paint0_linear_3816_12357)"
              fill-opacity="0.5"
            />
            <path
              d="M0 22C0 33.0457 8.9543 42 20 42H320C331.046 42 340 33.0457 340 22V0H0V22Z"
              fill="#FFD95E"
            />
            <defs>
              <linearGradient
                id="paint0_linear_3816_12357"
                x1="169.499"
                y1="42"
                x2="169.499"
                y2="1.00136e-05"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#D0FFF2" />
                <stop offset="1" stop-color="#9CECFF" />
              </linearGradient>
            </defs>
          </svg>
          <div style="position: absolute; bottom: 8px; left: 10px">
            阶 梯 式 成 长, 高 效 提 升 好 帮 手
          </div>
        </div>

        <div class="content">
          为帮助学生系统掌握数学基础知识和思想方法、提高解决问题的能力，帮助教师深层次地理解教材、创造性开展教学，学科网携近百位一线优秀
          教师创作小学数学特色资源专题，注重四基，紧扣课标，完美全覆盖讲练测全教学过程，助力学生构建知识体系，提高学科素养！
        </div>
      </div>

      <div class="start">
        <div>开启挑战营之旅</div>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="7"
          height="8"
          viewBox="0 0 7 8"
          fill="none"
        >
          <rect
            width="4.08346"
            height="1.22504"
            transform="matrix(0.764024 0.645187 -0.764024 0.645187 1.5072 3.88379)"
            fill="#424242"
          />
          <rect
            width="4.08346"
            height="1.22504"
            transform="matrix(-0.764024 0.645187 0.764024 0.645187 6.06433 3.88379)"
            fill="#424242"
          />
          <rect
            width="4.08346"
            height="1.22504"
            transform="matrix(0.764024 0.645187 -0.764024 0.645187 1.5072 0)"
            fill="#424242"
          />
          <rect
            width="4.08346"
            height="1.22504"
            transform="matrix(-0.764024 0.645187 0.764024 0.645187 6.06433 0)"
            fill="#424242"
          />
        </svg>
      </div>

      <div class="title">
        <div class="main-title">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="27"
            height="20"
            viewBox="0 0 27 20"
            fill="none"
          >
            <circle
              cx="9"
              cy="9"
              r="9"
              transform="matrix(-1 0 0 1 27 0.308838)"
              fill="#0072FF"
            />
            <circle
              cx="6"
              cy="6"
              r="6"
              transform="matrix(-1 0 0 1 12 7.30884)"
              fill="#008EFF"
            />
          </svg>
          计算题大通关
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="27"
            height="20"
            viewBox="0 0 27 20"
            fill="none"
          >
            <circle cx="9" cy="9.30884" r="9" fill="#0072FF" />
            <circle cx="21" cy="13.3088" r="6" fill="#008EFF" />
          </svg>
        </div>
      </div>

      <div class="resource-list">
        <div class="tabs">
          <div
            :class="
              completeCalculationProblemVersion == 1 ? 'checked' : 'unchecked'
            "
            data-io-click="tracker"  @click="changeVersion(1)"
          >
            人教版
          </div>
          <div
            :class="
              completeCalculationProblemVersion == 2 ? 'checked' : 'unchecked'
            "
            data-io-click="tracker"  @click="changeVersion(2)"
            style="margin-left: 10px"
          >
            苏教版
          </div>
          <div
            :class="
              completeCalculationProblemVersion == 3 ? 'checked' : 'unchecked'
            "
            data-io-click="tracker"  @click="changeVersion(3)"
            style="margin-left: 10px"
          >
            北师大版
          </div>
        </div>
        <div class="dataTwo">
          <div class="left">
            <img src="./images/mathImages/group26998.svg" />
            <div class="title">计算讲义+专练</div>
            <div class="describe">
              梳理各单元包含的计算模块内容，构建框架体系，配以最新的题源制作而成。
            </div>
            <div class="see-all" data-io-click="tracker"  @click="toAlbumPage(3293655)">查看全部</div>
          </div>
          <div class="right">
            <div
              class="resource"
              v-for="i in completeCalculationProblemDataOne"
              :key="i.id"
              data-io-click="tracker"  @click="toAlbumPage(i.id)"
              v-if="completeCalculationProblemVersion == 1"
            >
              <img src="./images/mathImages/group1805.svg" />
              <div class="grade">{{ i.grade }}</div>
              <div class="title">{{ i.title }}</div>
              <div v-if="i.id == 3274776" class="version" style="left: 21px">
                {{ i.version }}
              </div>
              <div v-else class="version">{{ i.version }}</div>
              <div class="see-all">查看全部</div>
            </div>
            <div
              class="resource"
              v-for="i in completeCalculationProblemDataTwo"
              :key="i.id"
              data-io-click="tracker"  @click="toAlbumPage(i.id)"
              v-if="completeCalculationProblemVersion == 2"
            >
              <img src="./images/mathImages/group1779.svg" />
              <div class="grade">{{ i.grade }}</div>
              <div class="title">{{ i.title }}</div>
              <div v-if="i.id == 3293615" class="version" style="left: 21px">
                {{ i.version }}
              </div>
              <div v-else class="version">{{ i.version }}</div>
              <div class="see-all">查看全部</div>
            </div>
            <div
              class="resource"
              v-for="i in completeCalculationProblemDataThree"
              :key="i.id"
              data-io-click="tracker"  @click="toAlbumPage(i.id)"
              v-if="completeCalculationProblemVersion == 3"
            >
              <img
                style="width: 132px; height: 185px"
                src="./images/mathImages/cover-box-1-2-1.png"
              />
              <div class="grade">{{ i.grade }}</div>
              <div class="title">{{ i.title }}</div>
              <div v-if="i.id == 3274791" class="version" style="left: 21px">
                {{ i.version }}
              </div>
              <div v-else class="version">{{ i.version }}</div>
              <div class="see-all">查看全部</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--    解决问题指导-->
    <div id="div2" class="problem-solving-guidance">
      <div class="title">
        <div class="main-title">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="27"
            height="20"
            viewBox="0 0 27 20"
            fill="none"
          >
            <circle
              cx="9"
              cy="9"
              r="9"
              transform="matrix(-1 0 0 1 27 0.308838)"
              fill="#0072FF"
            />
            <circle
              cx="6"
              cy="6"
              r="6"
              transform="matrix(-1 0 0 1 12 7.30884)"
              fill="#008EFF"
            />
          </svg>
          解决问题指导
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="27"
            height="20"
            viewBox="0 0 27 20"
            fill="none"
          >
            <circle cx="9" cy="9.30884" r="9" fill="#0072FF" />
            <circle cx="21" cy="13.3088" r="6" fill="#008EFF" />
          </svg>
        </div>
      </div>

      <div class="resource-list">
        <div class="tabs">
          <div
            :class="
              problemSolvingGuidanceVersion == 1 ? 'checked' : 'unchecked'
            "
            data-io-click="tracker"  @click="changeProblemVersion(1)"
          >
            人教版
          </div>
          <div
            :class="
              problemSolvingGuidanceVersion == 2 ? 'checked' : 'unchecked'
            "
            data-io-click="tracker"  @click="changeProblemVersion(2)"
            style="margin-left: 10px"
          >
            苏教版
          </div>
          <div
            :class="
              problemSolvingGuidanceVersion == 3 ? 'checked' : 'unchecked'
            "
            data-io-click="tracker"  @click="changeProblemVersion(3)"
            style="margin-left: 10px"
          >
            北师大版
          </div>
        </div>

        <div class="dataTwo">
          <div class="left">
            <img src="./images/mathImages/group26998.svg" />
            <div class="title">解决问题讲义+专练</div>
            <div class="describe">
              梳理各单元包含的计算模块内容，构建框架体系，配以最新的题源制作而成。
            </div>
            <div class="see-all" data-io-click="tracker"  @click="toAlbumPage(3303985)">查看全部</div>
          </div>
          <div class="right">
            <div
              class="resource"
              v-for="i in problemSolvingGuidanceDataOne"
              :key="i.id"
              v-if="problemSolvingGuidanceVersion == 1"
              data-io-click="tracker"  @click="toAlbumPage(i.id)"
            >
              <img src="./images/mathImages/group1811.svg" />
              <div class="grade">{{ i.grade }}</div>
              <div class="title">{{ i.title }}</div>
              <div class="version">{{ i.version }}</div>
              <div class="see-all">查看全部</div>
            </div>
            <div
              class="resource"
              v-for="i in problemSolvingGuidanceDataTwo"
              :key="i.id"
              v-if="problemSolvingGuidanceVersion == 2"
              data-io-click="tracker"  @click="toAlbumPage(i.id)"
            >
              <img src="./images/mathImages/cover-box-2-2-1.png" />
              <div class="grade">{{ i.grade }}</div>
              <div class="title">{{ i.title }}</div>
              <div class="version">{{ i.version }}</div>
              <div class="see-all">查看全部</div>
            </div>
            <div
              class="resource"
              v-for="i in problemSolvingGuidanceDataThree"
              :key="i.id"
              v-if="problemSolvingGuidanceVersion == 3"
              data-io-click="tracker"  @click="toAlbumPage(i.id)"
            >
              <img src="./images/mathImages/cover-box-2-3-1.png" />
              <div class="grade">{{ i.grade }}</div>
              <div class="title">{{ i.title }}</div>
              <div class="version">{{ i.version }}</div>
              <div class="see-all">查看全部</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--    典例易错变式-->
    <div id="div3" class="errors-and-variations">
      <div class="title">
        <div class="main-title">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="27"
            height="20"
            viewBox="0 0 27 20"
            fill="none"
          >
            <circle
              cx="9"
              cy="9"
              r="9"
              transform="matrix(-1 0 0 1 27 0.308838)"
              fill="#0072FF"
            />
            <circle
              cx="6"
              cy="6"
              r="6"
              transform="matrix(-1 0 0 1 12 7.30884)"
              fill="#008EFF"
            />
          </svg>
          典例易错变式
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="27"
            height="20"
            viewBox="0 0 27 20"
            fill="none"
          >
            <circle cx="9" cy="9.30884" r="9" fill="#0072FF" />
            <circle cx="21" cy="13.3088" r="6" fill="#008EFF" />
          </svg>
        </div>
      </div>

      <div class="resource-list">
        <div class="tabs">
          <div
            :class="errorsAndVariationsVersion == 1 ? 'checked' : 'unchecked'"
            data-io-click="tracker"  @click="changeVariationsVersion(1)"
          >
            小马虎错题本
          </div>
          <div
            :class="errorsAndVariationsVersion == 2 ? 'checked' : 'unchecked'"
            data-io-click="tracker"  @click="changeVariationsVersion(2)"
            style="margin-left: 10px"
          >
            举一反三
          </div>
          <div
            :class="errorsAndVariationsVersion == 3 ? 'checked' : 'unchecked'"
            data-io-click="tracker"  @click="changeVariationsVersion(3)"
            style="margin-left: 10px"
          >
            典例专项讲义
          </div>
          <div
            :class="errorsAndVariationsVersion == 4 ? 'checked' : 'unchecked'"
            data-io-click="tracker"  @click="changeVariationsVersion(4)"
            style="margin-left: 10px"
          >
            典型例题系列
          </div>
        </div>
        <div class="subtitle">
          梳理各单元易错知识点，进行错例分析及巩固练习，助学生归纳和总结，提升学习效率！
        </div>
        <div class="data">
          <div class="left">
            <img src="./images/mathImages/group27022.svg" />
          </div>
          <div class="right">
            <!--            左箭头-->
            <div
              v-if="errorsAndVariationsDataOne.length > 4"
              :class="
                optimizingMoveIndexThree == 1
                  ? 'left-arrow-disable'
                  : 'left-arrow'
              "
              data-io-click="tracker"  @click="moveTranBodyThree(1)"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="46"
                height="46"
                viewBox="0 0 46 46"
                fill="none"
              >
                <g filter="url(#filter0_d_3816_12658)">
                  <circle cx="23" cy="22" r="19" fill="white" />
                </g>
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M27.6907 13.2209C27.2329 12.8104 26.5048 12.8104 26.0469 13.2209L17.5756 20.8164C17.098 21.2446 17.098 21.9526 17.5756 22.3808C17.5817 22.3863 17.5879 22.3917 17.5941 22.3971L26.0474 29.9764C26.5053 30.3869 27.2334 30.3869 27.6912 29.9764C28.1688 29.5482 28.1688 28.8402 27.6912 28.412L20.092 21.5984L27.6907 14.7853C28.1683 14.3571 28.1683 13.6491 27.6907 13.2209Z"
                  fill="#A19CF0"
                />
                <defs>
                  <filter
                    id="filter0_d_3816_12658"
                    x="0"
                    y="0"
                    width="46"
                    height="46"
                    filterUnits="userSpaceOnUse"
                    color-interpolation-filters="sRGB"
                  >
                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                      in="SourceAlpha"
                      type="matrix"
                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                      result="hardAlpha"
                    />
                    <feOffset dy="1" />
                    <feGaussianBlur stdDeviation="2" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix
                      type="matrix"
                      values="0 0 0 0 0.360784 0 0 0 0 0.552941 0 0 0 0 0.858824 0 0 0 1 0"
                    />
                    <feBlend
                      mode="normal"
                      in2="BackgroundImageFix"
                      result="effect1_dropShadow_3816_12658"
                    />
                    <feBlend
                      mode="normal"
                      in="SourceGraphic"
                      in2="effect1_dropShadow_3816_12658"
                      result="shape"
                    />
                  </filter>
                </defs>
              </svg>
            </div>
            <!--            显示区域-->
            <div class="show-range">
              <!--            移动区域-->
              <div
                class="tran-body"
                :style="{
                  transform: 'translateX(' + optimizingMovelengthThree + 'px)',
                }"
              >
                <div
                  class="resource"
                  v-for="i in errorsAndVariationsDataOne"
                  :key="i.id"
                  data-io-click="tracker"  @click="toAlbumPage(i.id)"
                >
                  <img src="./images/mathImages/group1828.svg" />
                  <div class="grade">{{ i.grade }}</div>
                  <div class="title">{{ i.title }}</div>
                  <div class="version">{{ i.version }}</div>
                  <div class="see-all">查看全部</div>
                </div>
              </div>
            </div>
            <!--            右箭头-->
            <div
              v-if="errorsAndVariationsDataOne.length > 4"
              :class="
                optimizingMoveIndexThree == 3
                  ? 'right-arrow-disable'
                  : 'right-arrow'
              "
              data-io-click="tracker"  @click="moveTranBodyThree(2)"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="46"
                height="46"
                viewBox="0 0 46 46"
                fill="none"
              >
                <g filter="url(#filter0_d_3816_12658)">
                  <circle cx="23" cy="22" r="19" fill="white" />
                </g>
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M17.576 13.221C18.0338 12.8105 18.7619 12.8105 19.2198 13.221L27.6912 20.8165C28.1687 21.2446 28.1687 21.9527 27.6912 22.3808C27.685 22.3863 27.6789 22.3918 27.6726 22.3971L19.2193 29.9764C18.7615 30.3869 18.0333 30.3869 17.5755 29.9764C17.098 29.5482 17.098 28.8402 17.5755 28.412L25.1748 21.5985L17.576 14.7853C17.0984 14.3572 17.0984 13.6491 17.576 13.221Z"
                  fill="#A19CF0"
                />
                <defs>
                  <filter
                    id="filter0_d_3816_12658"
                    x="0"
                    y="0"
                    width="46"
                    height="46"
                    filterUnits="userSpaceOnUse"
                    color-interpolation-filters="sRGB"
                  >
                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                      in="SourceAlpha"
                      type="matrix"
                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                      result="hardAlpha"
                    />
                    <feOffset dy="1" />
                    <feGaussianBlur stdDeviation="2" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix
                      type="matrix"
                      values="0 0 0 0 0.360784 0 0 0 0 0.552941 0 0 0 0 0.858824 0 0 0 1 0"
                    />
                    <feBlend
                      mode="normal"
                      in2="BackgroundImageFix"
                      result="effect1_dropShadow_3816_12658"
                    />
                    <feBlend
                      mode="normal"
                      in="SourceGraphic"
                      in2="effect1_dropShadow_3816_12658"
                      result="shape"
                    />
                  </filter>
                </defs>
              </svg>
            </div>
          </div>
        </div>

        <div class="data" style="margin-top: 38px">
          <div class="left">
            <img src="./images/mathImages/group27000.svg" />
          </div>
          <div class="right">
            <!--            左箭头-->
            <div
              v-if="errorsAndVariationsDataTwo.length > 4"
              :class="
                optimizingMoveIndexFour == 1
                  ? 'left-arrow-disable'
                  : 'left-arrow'
              "
              data-io-click="tracker"  @click="moveTranBodyFour(1)"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="46"
                height="46"
                viewBox="0 0 46 46"
                fill="none"
              >
                <g filter="url(#filter0_d_3816_12658)">
                  <circle cx="23" cy="22" r="19" fill="white" />
                </g>
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M27.6907 13.2209C27.2329 12.8104 26.5048 12.8104 26.0469 13.2209L17.5756 20.8164C17.098 21.2446 17.098 21.9526 17.5756 22.3808C17.5817 22.3863 17.5879 22.3917 17.5941 22.3971L26.0474 29.9764C26.5053 30.3869 27.2334 30.3869 27.6912 29.9764C28.1688 29.5482 28.1688 28.8402 27.6912 28.412L20.092 21.5984L27.6907 14.7853C28.1683 14.3571 28.1683 13.6491 27.6907 13.2209Z"
                  fill="#A19CF0"
                />
                <defs>
                  <filter
                    id="filter0_d_3816_12658"
                    x="0"
                    y="0"
                    width="46"
                    height="46"
                    filterUnits="userSpaceOnUse"
                    color-interpolation-filters="sRGB"
                  >
                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                      in="SourceAlpha"
                      type="matrix"
                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                      result="hardAlpha"
                    />
                    <feOffset dy="1" />
                    <feGaussianBlur stdDeviation="2" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix
                      type="matrix"
                      values="0 0 0 0 0.360784 0 0 0 0 0.552941 0 0 0 0 0.858824 0 0 0 1 0"
                    />
                    <feBlend
                      mode="normal"
                      in2="BackgroundImageFix"
                      result="effect1_dropShadow_3816_12658"
                    />
                    <feBlend
                      mode="normal"
                      in="SourceGraphic"
                      in2="effect1_dropShadow_3816_12658"
                      result="shape"
                    />
                  </filter>
                </defs>
              </svg>
            </div>
            <!--            显示区域-->
            <div class="show-range">
              <!--            移动区域-->
              <div
                class="tran-body"
                :style="{
                  transform: 'translateX(' + optimizingMovelengthFour + 'px)',
                }"
              >
                <div
                  class="resource"
                  v-for="i in errorsAndVariationsDataTwo"
                  :key="i.id"
                  data-io-click="tracker"  @click="toAlbumPage(i.id)"
                >
                  <img src="./images/mathImages/group1833.svg" />
                  <div class="grade">{{ i.grade }}</div>
                  <div class="title" style="color: #4e11f4">{{ i.title }}</div>
                  <div class="version" style="color: #4e11f4">
                    {{ i.version }}
                  </div>
                  <div class="see-all" style="background: #ebd9fd">
                    查看全部
                  </div>
                </div>
              </div>
            </div>
            <!--            右箭头-->
            <div
              v-if="errorsAndVariationsDataTwo.length > 4"
              :class="
                optimizingMoveIndexFour == 3
                  ? 'right-arrow-disable'
                  : 'right-arrow'
              "
              data-io-click="tracker"  @click="moveTranBodyFour(2)"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="46"
                height="46"
                viewBox="0 0 46 46"
                fill="none"
              >
                <g filter="url(#filter0_d_3816_12658)">
                  <circle cx="23" cy="22" r="19" fill="white" />
                </g>
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M17.576 13.221C18.0338 12.8105 18.7619 12.8105 19.2198 13.221L27.6912 20.8165C28.1687 21.2446 28.1687 21.9527 27.6912 22.3808C27.685 22.3863 27.6789 22.3918 27.6726 22.3971L19.2193 29.9764C18.7615 30.3869 18.0333 30.3869 17.5755 29.9764C17.098 29.5482 17.098 28.8402 17.5755 28.412L25.1748 21.5985L17.576 14.7853C17.0984 14.3572 17.0984 13.6491 17.576 13.221Z"
                  fill="#A19CF0"
                />
                <defs>
                  <filter
                    id="filter0_d_3816_12658"
                    x="0"
                    y="0"
                    width="46"
                    height="46"
                    filterUnits="userSpaceOnUse"
                    color-interpolation-filters="sRGB"
                  >
                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                      in="SourceAlpha"
                      type="matrix"
                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                      result="hardAlpha"
                    />
                    <feOffset dy="1" />
                    <feGaussianBlur stdDeviation="2" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix
                      type="matrix"
                      values="0 0 0 0 0.360784 0 0 0 0 0.552941 0 0 0 0 0.858824 0 0 0 1 0"
                    />
                    <feBlend
                      mode="normal"
                      in2="BackgroundImageFix"
                      result="effect1_dropShadow_3816_12658"
                    />
                    <feBlend
                      mode="normal"
                      in="SourceGraphic"
                      in2="effect1_dropShadow_3816_12658"
                      result="shape"
                    />
                  </filter>
                </defs>
              </svg>
            </div>
          </div>
        </div>

        <div class="data" style="margin-top: 38px">
          <div class="left">
            <img src="./images/mathImages/group27001.svg" />
          </div>
          <div class="right">
            <!--            左箭头-->
            <div
              v-if="errorsAndVariationsDataThree.length > 4"
              :class="
                optimizingMoveIndexFive == 1
                  ? 'left-arrow-disable'
                  : 'left-arrow'
              "
              data-io-click="tracker"  @click="moveTranBodyFive(1)"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="46"
                height="46"
                viewBox="0 0 46 46"
                fill="none"
              >
                <g filter="url(#filter0_d_3816_12658)">
                  <circle cx="23" cy="22" r="19" fill="white" />
                </g>
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M27.6907 13.2209C27.2329 12.8104 26.5048 12.8104 26.0469 13.2209L17.5756 20.8164C17.098 21.2446 17.098 21.9526 17.5756 22.3808C17.5817 22.3863 17.5879 22.3917 17.5941 22.3971L26.0474 29.9764C26.5053 30.3869 27.2334 30.3869 27.6912 29.9764C28.1688 29.5482 28.1688 28.8402 27.6912 28.412L20.092 21.5984L27.6907 14.7853C28.1683 14.3571 28.1683 13.6491 27.6907 13.2209Z"
                  fill="#A19CF0"
                />
                <defs>
                  <filter
                    id="filter0_d_3816_12658"
                    x="0"
                    y="0"
                    width="46"
                    height="46"
                    filterUnits="userSpaceOnUse"
                    color-interpolation-filters="sRGB"
                  >
                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                      in="SourceAlpha"
                      type="matrix"
                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                      result="hardAlpha"
                    />
                    <feOffset dy="1" />
                    <feGaussianBlur stdDeviation="2" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix
                      type="matrix"
                      values="0 0 0 0 0.360784 0 0 0 0 0.552941 0 0 0 0 0.858824 0 0 0 1 0"
                    />
                    <feBlend
                      mode="normal"
                      in2="BackgroundImageFix"
                      result="effect1_dropShadow_3816_12658"
                    />
                    <feBlend
                      mode="normal"
                      in="SourceGraphic"
                      in2="effect1_dropShadow_3816_12658"
                      result="shape"
                    />
                  </filter>
                </defs>
              </svg>
            </div>
            <!--            显示区域-->
            <div class="show-range">
              <!--            移动区域-->
              <div
                class="tran-body"
                :style="{
                  transform: 'translateX(' + optimizingMovelengthFive + 'px)',
                }"
              >
                <div
                  class="resource"
                  v-for="i in errorsAndVariationsDataThree"
                  :key="i.id"
                  data-io-click="tracker"  @click="toAlbumPage(i.id)"
                >
                  <img src="./images/mathImages/group1838.svg" />
                  <div class="grade">{{ i.grade }}</div>
                  <div class="title" style="color: #3900d4">{{ i.title }}</div>
                  <div class="version" style="color: #3900d4">
                    {{ i.version }}
                  </div>
                  <div class="see-all" style="background: #ebd7fe">
                    查看全部
                  </div>
                </div>
              </div>
            </div>
            <!--            右箭头-->
            <div
              v-if="errorsAndVariationsDataThree.length > 4"
              :class="
                optimizingMoveIndexFive == 3
                  ? 'right-arrow-disable'
                  : 'right-arrow'
              "
              data-io-click="tracker"  @click="moveTranBodyFive(2)"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="46"
                height="46"
                viewBox="0 0 46 46"
                fill="none"
              >
                <g filter="url(#filter0_d_3816_12658)">
                  <circle cx="23" cy="22" r="19" fill="white" />
                </g>
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M17.576 13.221C18.0338 12.8105 18.7619 12.8105 19.2198 13.221L27.6912 20.8165C28.1687 21.2446 28.1687 21.9527 27.6912 22.3808C27.685 22.3863 27.6789 22.3918 27.6726 22.3971L19.2193 29.9764C18.7615 30.3869 18.0333 30.3869 17.5755 29.9764C17.098 29.5482 17.098 28.8402 17.5755 28.412L25.1748 21.5985L17.576 14.7853C17.0984 14.3572 17.0984 13.6491 17.576 13.221Z"
                  fill="#A19CF0"
                />
                <defs>
                  <filter
                    id="filter0_d_3816_12658"
                    x="0"
                    y="0"
                    width="46"
                    height="46"
                    filterUnits="userSpaceOnUse"
                    color-interpolation-filters="sRGB"
                  >
                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                      in="SourceAlpha"
                      type="matrix"
                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                      result="hardAlpha"
                    />
                    <feOffset dy="1" />
                    <feGaussianBlur stdDeviation="2" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix
                      type="matrix"
                      values="0 0 0 0 0.360784 0 0 0 0 0.552941 0 0 0 0 0.858824 0 0 0 1 0"
                    />
                    <feBlend
                      mode="normal"
                      in2="BackgroundImageFix"
                      result="effect1_dropShadow_3816_12658"
                    />
                    <feBlend
                      mode="normal"
                      in="SourceGraphic"
                      in2="effect1_dropShadow_3816_12658"
                      result="shape"
                    />
                  </filter>
                </defs>
              </svg>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--    思想方法培优-->
    <div id="div4" class="optimizing-ideological-methods">
      <div class="title">
        <div class="main-title">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="27"
            height="20"
            viewBox="0 0 27 20"
            fill="none"
          >
            <circle
              cx="9"
              cy="9"
              r="9"
              transform="matrix(-1 0 0 1 27 0.308838)"
              fill="#0072FF"
            />
            <circle
              cx="6"
              cy="6"
              r="6"
              transform="matrix(-1 0 0 1 12 7.30884)"
              fill="#008EFF"
            />
          </svg>
          思想方法培优
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="27"
            height="20"
            viewBox="0 0 27 20"
            fill="none"
          >
            <circle cx="9" cy="9.30884" r="9" fill="#0072FF" />
            <circle cx="21" cy="13.3088" r="6" fill="#008EFF" />
          </svg>
        </div>
      </div>

      <div class="resource-list">
        <div class="data">
          <div class="left">
            <img src="./images/mathImages/group26998.svg" />
            <div class="title">数学思想方法</div>
            <div class="describe">
              结合教学实例深度讲解，把握知识本质，提炼思想方法，体验抽象过程，感受数学之美。
            </div>
            <div class="see-all" data-io-click="tracker"  @click="toAlbumPage(3068765)">查看全部</div>
          </div>
          <div class="right">
            <!--            左箭头-->
            <div
              :class="
                optimizingMoveIndexOne == 1
                  ? 'left-arrow-disable'
                  : 'left-arrow'
              "
              data-io-click="tracker"  @click="moveTranBody(1)"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="46"
                height="46"
                viewBox="0 0 46 46"
                fill="none"
              >
                <g filter="url(#filter0_d_3816_12893)">
                  <circle cx="23" cy="22" r="19" fill="white" />
                </g>
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M27.6907 13.2209C27.2329 12.8104 26.5048 12.8104 26.0469 13.2209L17.5756 20.8164C17.098 21.2446 17.098 21.9526 17.5756 22.3808C17.5817 22.3863 17.5879 22.3917 17.5941 22.397L26.0474 29.9763C26.5053 30.3868 27.2334 30.3868 27.6912 29.9763C28.1688 29.5482 28.1688 28.8401 27.6912 28.412L20.092 21.5984L27.6907 14.7853C28.1683 14.3571 28.1683 13.6491 27.6907 13.2209Z"
                  fill="#FDBF1E"
                />
                <defs>
                  <filter
                    id="filter0_d_3816_12893"
                    x="0"
                    y="0"
                    width="46"
                    height="46"
                    filterUnits="userSpaceOnUse"
                    color-interpolation-filters="sRGB"
                  >
                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                      in="SourceAlpha"
                      type="matrix"
                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                      result="hardAlpha"
                    />
                    <feOffset dy="1" />
                    <feGaussianBlur stdDeviation="2" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix
                      type="matrix"
                      values="0 0 0 0 1 0 0 0 0 0.643137 0 0 0 0 0.0941176 0 0 0 1 0"
                    />
                    <feBlend
                      mode="normal"
                      in2="BackgroundImageFix"
                      result="effect1_dropShadow_3816_12893"
                    />
                    <feBlend
                      mode="normal"
                      in="SourceGraphic"
                      in2="effect1_dropShadow_3816_12893"
                      result="shape"
                    />
                  </filter>
                </defs>
              </svg>
            </div>
            <!--            显示区域-->
            <div class="show-range">
              <!--            移动区域-->
              <div
                class="tran-body"
                :style="{
                  transform: 'translateX(' + optimizingMovelengthOne + 'px)',
                }"
              >
                <div
                  class="resource"
                  v-for="i in optimizingIdeologicalMethodsDataOne"
                  :key="i.id"
                  data-io-click="tracker"  @click="toAlbumPage(i.id)"
                >
                  <img src="./images/mathImages/group17791.svg" />
                  <div class="grade">{{ i.grade }}</div>
                  <div class="title">{{ i.title }}</div>
                  <div class="version">{{ i.version }}</div>
                  <div class="see-all">查看全部</div>
                </div>
              </div>
            </div>
            <!--            右箭头-->
            <div
              :class="
                optimizingMoveIndexOne == 3
                  ? 'right-arrow-disable'
                  : 'right-arrow'
              "
              data-io-click="tracker"  @click="moveTranBody(2)"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="46"
                height="46"
                viewBox="0 0 46 46"
                fill="none"
              >
                <g filter="url(#filter0_d_3816_12898)">
                  <circle class="circle" cx="23" cy="22" r="19" fill="white" />
                </g>
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M17.576 13.221C18.0338 12.8105 18.7619 12.8105 19.2198 13.221L27.6912 20.8165C28.1687 21.2446 28.1687 21.9527 27.6912 22.3808C27.685 22.3863 27.6789 22.3918 27.6726 22.3971L19.2193 29.9764C18.7615 30.3869 18.0333 30.3869 17.5755 29.9764C17.098 29.5482 17.098 28.8402 17.5755 28.412L25.1748 21.5985L17.576 14.7853C17.0984 14.3572 17.0984 13.6491 17.576 13.221Z"
                  fill="#FDBF1E"
                />
                <defs>
                  <filter
                    id="filter0_d_3816_12898"
                    x="0"
                    y="0"
                    width="46"
                    height="46"
                    filterUnits="userSpaceOnUse"
                    color-interpolation-filters="sRGB"
                  >
                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                      in="SourceAlpha"
                      type="matrix"
                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                      result="hardAlpha"
                    />
                    <feOffset dy="1" />
                    <feGaussianBlur stdDeviation="2" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix
                      type="matrix"
                      values="0 0 0 0 1 0 0 0 0 0.643137 0 0 0 0 0.0941176 0 0 0 1 0"
                    />
                    <feBlend
                      mode="normal"
                      in2="BackgroundImageFix"
                      result="effect1_dropShadow_3816_12898"
                    />
                    <feBlend
                      mode="normal"
                      in="SourceGraphic"
                      in2="effect1_dropShadow_3816_12898"
                      result="shape"
                    />
                  </filter>
                </defs>
              </svg>
            </div>
          </div>
        </div>
        <div class="data">
          <div class="left">
            <img src="./images/mathImages/group26998.svg" />
            <div class="title">习题深度解析</div>
            <div class="describe">
              全面解读教材练习题，深挖背后设计意图和设计思路，总结提炼其中包含的数学思想和方法技巧。
            </div>
            <div class="see-all" data-io-click="tracker"  @click="toAlbumPage(3066103)">查看全部</div>
          </div>
          <div class="right">
            <!--            左箭头-->
            <div
              :class="
                optimizingMoveIndexTwo == 1
                  ? 'left-arrow-disable'
                  : 'left-arrow'
              "
              data-io-click="tracker"  @click="moveTranBodyTwo(1)"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="46"
                height="46"
                viewBox="0 0 46 46"
                fill="none"
              >
                <g filter="url(#filter0_d_3816_12893)">
                  <circle cx="23" cy="22" r="19" fill="white" />
                </g>
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M27.6907 13.2209C27.2329 12.8104 26.5048 12.8104 26.0469 13.2209L17.5756 20.8164C17.098 21.2446 17.098 21.9526 17.5756 22.3808C17.5817 22.3863 17.5879 22.3917 17.5941 22.397L26.0474 29.9763C26.5053 30.3868 27.2334 30.3868 27.6912 29.9763C28.1688 29.5482 28.1688 28.8401 27.6912 28.412L20.092 21.5984L27.6907 14.7853C28.1683 14.3571 28.1683 13.6491 27.6907 13.2209Z"
                  fill="#FDBF1E"
                />
                <defs>
                  <filter
                    id="filter0_d_3816_12893"
                    x="0"
                    y="0"
                    width="46"
                    height="46"
                    filterUnits="userSpaceOnUse"
                    color-interpolation-filters="sRGB"
                  >
                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                      in="SourceAlpha"
                      type="matrix"
                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                      result="hardAlpha"
                    />
                    <feOffset dy="1" />
                    <feGaussianBlur stdDeviation="2" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix
                      type="matrix"
                      values="0 0 0 0 1 0 0 0 0 0.643137 0 0 0 0 0.0941176 0 0 0 1 0"
                    />
                    <feBlend
                      mode="normal"
                      in2="BackgroundImageFix"
                      result="effect1_dropShadow_3816_12893"
                    />
                    <feBlend
                      mode="normal"
                      in="SourceGraphic"
                      in2="effect1_dropShadow_3816_12893"
                      result="shape"
                    />
                  </filter>
                </defs>
              </svg>
            </div>
            <!--            显示区域-->
            <div class="show-range">
              <!--            移动区域-->
              <div
                class="tran-body"
                :style="{
                  transform: 'translateX(' + optimizingMovelengthTwo + 'px)',
                }"
              >
                <div
                  class="resource"
                  v-for="i in optimizingIdeologicalMethodsDataTwo"
                  :key="i.id"
                  data-io-click="tracker"  @click="toAlbumPage(i.id)"
                >
                  <img src="./images/mathImages/group17792.svg" />
                  <div class="grade">{{ i.grade }}</div>
                  <div class="title">{{ i.title }}</div>
                  <div class="version">{{ i.version }}</div>
                  <div class="see-all">查看全部</div>
                </div>
              </div>
            </div>
            <!--            右箭头-->
            <div
              :class="
                optimizingMoveIndexTwo == 3
                  ? 'right-arrow-disable'
                  : 'right-arrow'
              "
              data-io-click="tracker"  @click="moveTranBodyTwo(2)"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="46"
                height="46"
                viewBox="0 0 46 46"
                fill="none"
              >
                <g filter="url(#filter0_d_3816_12898)">
                  <circle cx="23" cy="22" r="19" fill="white" />
                </g>
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M17.576 13.221C18.0338 12.8105 18.7619 12.8105 19.2198 13.221L27.6912 20.8165C28.1687 21.2446 28.1687 21.9527 27.6912 22.3808C27.685 22.3863 27.6789 22.3918 27.6726 22.3971L19.2193 29.9764C18.7615 30.3869 18.0333 30.3869 17.5755 29.9764C17.098 29.5482 17.098 28.8402 17.5755 28.412L25.1748 21.5985L17.576 14.7853C17.0984 14.3572 17.0984 13.6491 17.576 13.221Z"
                  fill="#FDBF1E"
                />
                <defs>
                  <filter
                    id="filter0_d_3816_12898"
                    x="0"
                    y="0"
                    width="46"
                    height="46"
                    filterUnits="userSpaceOnUse"
                    color-interpolation-filters="sRGB"
                  >
                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                      in="SourceAlpha"
                      type="matrix"
                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                      result="hardAlpha"
                    />
                    <feOffset dy="1" />
                    <feGaussianBlur stdDeviation="2" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix
                      type="matrix"
                      values="0 0 0 0 1 0 0 0 0 0.643137 0 0 0 0 0.0941176 0 0 0 1 0"
                    />
                    <feBlend
                      mode="normal"
                      in2="BackgroundImageFix"
                      result="effect1_dropShadow_3816_12898"
                    />
                    <feBlend
                      mode="normal"
                      in="SourceGraphic"
                      in2="effect1_dropShadow_3816_12898"
                      result="shape"
                    />
                  </filter>
                </defs>
              </svg>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--    思维拓展训练-->
    <div id="div5" class="mind-expansion-training">
      <div class="title">
        <div class="main-title">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="27"
            height="20"
            viewBox="0 0 27 20"
            fill="none"
          >
            <circle
              cx="9"
              cy="9"
              r="9"
              transform="matrix(-1 0 0 1 27 0.308838)"
              fill="#0072FF"
            />
            <circle
              cx="6"
              cy="6"
              r="6"
              transform="matrix(-1 0 0 1 12 7.30884)"
              fill="#008EFF"
            />
          </svg>
          思维拓展训练
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="27"
            height="20"
            viewBox="0 0 27 20"
            fill="none"
          >
            <circle cx="9" cy="9.30884" r="9" fill="#0072FF" />
            <circle cx="21" cy="13.3088" r="6" fill="#008EFF" />
          </svg>
        </div>
      </div>

      <div class="resource-list">
        <div class="data">
          <div class="left">
            <img src="./images/mathImages/group26998.svg" />
            <div class="title">小升初思维拓展讲义</div>
            <div class="describe">
              梳理知识体系，注重思维训练，重视学生应用知识解决问题能力的培养。
            </div>
            <div class="see-all" data-io-click="tracker"  @click="toAlbumPage(3283827)">查看全部</div>
          </div>
          <div class="right">
            <div
              class="resource"
              v-for="i in mindExpansionTrainingDataOne"
              :key="i.id"
              data-io-click="tracker"  @click="toResourcePage(i.id)"
            >
              <div class="title">{{ i.title }}</div>
              <div class="see-info">查看</div>
            </div>
            <div class="see-all" data-io-click="tracker"  @click="toAlbumPage(3283827)">查看全部>></div>
          </div>
        </div>

        <div class="data">
          <div class="left">
            <img src="./images/mathImages/group26998.svg" />
            <div class="title">从课本到奥数拓展讲义</div>
            <div class="describe">
              与课内同步联动，拓展数学学习的深度和广度，进一步培养数学各项能力。
            </div>
            <div class="see-all" data-io-click="tracker"  @click="toAlbumPage(3086570)">查看全部</div>
          </div>
          <div class="right">
            <div
              class="resource"
              v-for="i in mindExpansionTrainingDataTwo"
              :key="i.id"
              data-io-click="tracker"  @click="toResourcePage(i.id)"
            >
              <div class="title">{{ i.title }}</div>
              <div class="see-info">查看</div>
            </div>
            <div class="see-all" data-io-click="tracker"  @click="toAlbumPage(3086570)">查看全部>></div>
          </div>
        </div>

        <div class="data">
          <div class="left">
            <img src="./images/mathImages/group26998.svg" />
            <div class="title">尖子生高分题库</div>
            <div class="describe">
              用科学的方法立体解读数学知识、数学题型、生活数学，培养学生思维能力。
            </div>
            <div class="see-all" data-io-click="tracker"  @click="toAlbumPage(3057641)">查看全部</div>
          </div>
          <div class="right">
            <div
              class="img-resource"
              v-for="i in mindExpansionTrainingDataThree"
              :key="i.id"
              data-io-click="tracker"  @click="toAlbumPage(i.id)"
            >
              <img src="./images/mathImages/group1858.svg" />
              <div class="grade">{{ i.grade }}</div>
              <div class="title">{{ i.title }}</div>
              <div class="version">{{ i.version }}</div>
              <div class="see-all">查看全部</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--    趣味数学乐园-->
    <div id="div6" class="fun-math-paradise">
      <div class="title">
        <div class="main-title">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="27"
            height="20"
            viewBox="0 0 27 20"
            fill="none"
          >
            <circle
              cx="9"
              cy="9"
              r="9"
              transform="matrix(-1 0 0 1 27 0.308838)"
              fill="#0072FF"
            />
            <circle
              cx="6"
              cy="6"
              r="6"
              transform="matrix(-1 0 0 1 12 7.30884)"
              fill="#008EFF"
            />
          </svg>
          趣味数学乐园
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="27"
            height="20"
            viewBox="0 0 27 20"
            fill="none"
          >
            <circle cx="9" cy="9.30884" r="9" fill="#0072FF" />
            <circle cx="21" cy="13.3088" r="6" fill="#008EFF" />
          </svg>
        </div>
      </div>

      <div class="resource-list">
        <div class="img-list">
          <div
            class="resource"
            style="margin-left: 42px"
            data-io-click="tracker"  @click="toAlbumPage(3070098)"
          >
            <img src="./images/mathImages/1.svg" />
            <div class="describe">知识寻本溯源，实际应用</div>
          </div>
          <div class="resource" data-io-click="tracker"  @click="toAlbumPage(2329422)">
            <img src="./images/mathImages/2.svg" />
            <div class="describe">知识寻本溯源，实际应用</div>
          </div>
          <div class="resource" data-io-click="tracker"  @click="toAlbumPage(2331235)">
            <img src="./images/mathImages/3.svg" />
            <div class="describe">知识寻本溯源，实际应用</div>
          </div>
          <div class="resource" data-io-click="tracker"  @click="toAlbumPage(2329636)">
            <img src="./images/mathImages/4.svg" />
            <div class="describe">知识寻本溯源，实际应用</div>
          </div>
          <div class="resource" data-io-click="tracker"  @click="toAlbumPage(2329971)">
            <img src="./images/mathImages/5.svg" />
            <div class="describe">知识寻本溯源，实际应用</div>
          </div>
        </div>
      </div>
    </div>

    <!--    侧边导航-->
    <div class="side">
      <a href="#div1">
        <div
          data-io-click="tracker"  @click="changeSide(1)"
          :class="{ 'side-checked': checkSideId == 1 }"
          class="title-1"
        >
          计算题大通关
        </div>
      </a>
      <a href="#div2"
        ><div
          data-io-click="tracker"  @click="changeSide(2)"
          :class="{ 'side-checked': checkSideId == 2 }"
          class="title-2"
        >
          解决问题指导
        </div></a
      >
      <a href="#div3"
        ><div
          data-io-click="tracker"  @click="changeSide(3)"
          :class="{ 'side-checked': checkSideId == 3 }"
          class="title-3"
        >
          典例易错变式
        </div></a
      >
      <a href="#div4">
        <div
          data-io-click="tracker"  @click="changeSide(4)"
          :class="{ 'side-checked': checkSideId == 4 }"
          class="title-4"
        >
          思想方法培优
        </div>
      </a>
      <a href="#div5">
        <div
          data-io-click="tracker"  @click="changeSide(5)"
          :class="{ 'side-checked': checkSideId == 5 }"
          class="title-5"
        >
          思维拓展训练
        </div>
      </a>
      <a href="#div6">
        <div
          data-io-click="tracker"  @click="changeSide(6)"
          :class="{ 'side-checked': checkSideId == 6 }"
          class="title-6"
        >
          趣味数学乐园
        </div>
      </a>
      <img class="bar" src="./images/mathImages/sidebar.svg" />
      <a href="#top"
        ><img class="back" src="./images/mathImages/backTop.svg"
      /></a>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      optimizingMovelengthThree: 0,
      optimizingMovelengthFour: 0,
      optimizingMovelengthFive: 0,
      optimizingMoveIndexThree: 1,
      optimizingMoveIndexFour: 1,
      optimizingMoveIndexFive: 1,
      checkSideId: 1,
      completeCalculationProblemDataOne: [
        {
          id: 3274776,
          grade: "一年级",
          title: "计算大通关",
          version: "人教版•2024秋",
        },
        {
          id: 3293655,
          grade: "二年级",
          title: "计算大通关",
          version: "人教版",
        },
        {
          id: 3274773,
          grade: "三年级",
          title: "计算大通关",
          version: "人教版",
        },
        {
          id: 3274772,
          grade: "四年级",
          title: "计算大通关",
          version: "人教版",
        },
        {
          id: 3274771,
          grade: "五年级",
          title: "计算大通关",
          version: "人教版",
        },
        {
          id: 3274770,
          grade: "六年级",
          title: "计算大通关",
          version: "人教版",
        },
      ],
      completeCalculationProblemDataTwo: [
        {
          id: 3293615,
          grade: "一年级",
          title: "计算大通关",
          version: "苏教版•2024秋",
        },
        {
          id: 3274768,
          grade: "二年级",
          title: "计算大通关",
          version: "苏教版",
        },
        {
          id: 3274782,
          grade: "三年级",
          title: "计算大通关",
          version: "苏教版",
        },
        {
          id: 3274780,
          grade: "四年级",
          title: "计算大通关",
          version: "苏教版",
        },
        {
          id: 3274784,
          grade: "五年级",
          title: "计算大通关",
          version: "苏教版",
        },
        {
          id: 3293655,
          grade: "六年级",
          title: "计算大通关",
          version: "苏教版",
        },
      ],
      completeCalculationProblemDataThree: [
        {
          id: 3274791,
          grade: "一年级",
          title: "计算大通关",
          version: "北师大版•2024秋",
        },
        {
          id: 3274808,
          grade: "二年级",
          title: "计算大通关",
          version: "北师大版",
        },
        {
          id: 3274807,
          grade: "三年级",
          title: "计算大通关",
          version: "北师大版",
        },
        {
          id: 3274806,
          grade: "四年级",
          title: "计算大通关",
          version: "北师大版",
        },
        {
          id: 3274805,
          grade: "五年级",
          title: "计算大通关",
          version: "北师大版",
        },
        {
          id: 3274811,
          grade: "六年级",
          title: "计算大通关",
          version: "北师大版",
        },
      ],
      optimizingIdeologicalMethodsDataOne: [
        {
          id: 3064934,
          grade: "一年级",
          title: "数学思想方法",
          version: "人教版",
        },
        {
          id: 3064936,
          grade: "二年级",
          title: "数学思想方法",
          version: "人教版",
        },
        {
          id: 3064938,
          grade: "三年级",
          title: "数学思想方法",
          version: "人教版",
        },
        {
          id: 3064939,
          grade: "四年级",
          title: "数学思想方法",
          version: "人教版",
        },
        {
          id: 3064940,
          grade: "五年级",
          title: "数学思想方法",
          version: "人教版",
        },
        {
          id: 3064941,
          grade: "六年级",
          title: "数学思想方法",
          version: "人教版",
        },
      ],
      optimizingIdeologicalMethodsDataTwo: [
        {
          id: 3066554,
          grade: "一年级",
          title: "教材习题剖析",
          version: "人教版",
        },
        {
          id: 3066555,
          grade: "二年级",
          title: "教材习题剖析",
          version: "人教版",
        },
        {
          id: 3066556,
          grade: "三年级",
          title: "教材习题剖析",
          version: "人教版",
        },
        {
          id: 3066557,
          grade: "四年级",
          title: "教材习题剖析",
          version: "人教版",
        },
        {
          id: 3066558,
          grade: "五年级",
          title: "教材习题剖析",
          version: "人教版",
        },
        {
          id: 3066559,
          grade: "六年级",
          title: "教材习题剖析",
          version: "人教版",
        },
      ],
      completeCalculationProblemVersion: 1,
      problemSolvingGuidanceDataOne: [
        {
          id: 3303993,
          grade: "三年级",
          title: "解决问题专项",
          version: "人教版",
        },
        {
          id: 3303992,
          grade: "四年级",
          title: "解决问题专项",
          version: "人教版",
        },
        {
          id: 3303991,
          grade: "五年级",
          title: "解决问题专项",
          version: "人教版",
        },
        {
          id: 3303990,
          grade: "六年级",
          title: "解决问题专项",
          version: "人教版",
        },
      ],
      problemSolvingGuidanceDataTwo: [
        {
          id: 3304000,
          grade: "三年级",
          title: "解决问题专项",
          version: "苏教版",
        },
        {
          id: 3303999,
          grade: "四年级",
          title: "解决问题专项",
          version: "苏教版",
        },
        {
          id: 3303997,
          grade: "五年级",
          title: "解决问题专项",
          version: "苏教版",
        },
        {
          id: 3303995,
          grade: "六年级",
          title: "解决问题专项",
          version: "苏教版",
        },
      ],
      problemSolvingGuidanceDataThree: [
        {
          id: 3304006,
          grade: "三年级",
          title: "解决问题专项",
          version: "北师大版",
        },
        {
          id: 3304005,
          grade: "四年级",
          title: "解决问题专项",
          version: "北师大版",
        },
        {
          id: 3304004,
          grade: "五年级",
          title: "解决问题专项",
          version: "北师大版",
        },
        {
          id: 3304003,
          grade: "六年级",
          title: "解决问题专项",
          version: "北师大版",
        },
      ],
      problemSolvingGuidanceVersion: 1,
      errorsAndVariationsVersion: 1,
      errorsAndVariationsDataOne: [
        {
          id: 3275809,
          grade: "一年级",
          title: "小马虎错题本",
          version: "人教版•2024秋",
        },
        {
          id: 3293626,
          grade: "二年级",
          title: "小马虎错题本",
          version: "人教版",
        },
        {
          id: 3275805,
          grade: "三年级",
          title: "小马虎错题本",
          version: "人教版",
        },
        {
          id: 3275806,
          grade: "四年级",
          title: "小马虎错题本",
          version: "人教版",
        },
        {
          id: 3275804,
          grade: "五年级",
          title: "小马虎错题本",
          version: "人教版",
        },
        {
          id: 3275803,
          grade: "六年级",
          title: "小马虎错题本",
          version: "人教版",
        },
      ],
      errorsAndVariationsDataOneFirst: [
        {
          id: 3275809,
          grade: "一年级",
          title: "小马虎错题本",
          version: "人教版•2024秋",
        },
        {
          id: 3293626,
          grade: "二年级",
          title: "小马虎错题本",
          version: "人教版",
        },
        {
          id: 3275805,
          grade: "三年级",
          title: "小马虎错题本",
          version: "人教版",
        },
        {
          id: 3275806,
          grade: "四年级",
          title: "小马虎错题本",
          version: "人教版",
        },
        {
          id: 3275804,
          grade: "五年级",
          title: "小马虎错题本",
          version: "人教版",
        },
        {
          id: 3275803,
          grade: "六年级",
          title: "小马虎错题本",
          version: "人教版",
        },
      ],
      errorsAndVariationsDataOneSecond: [
        {
          id: 3279463,
          grade: "一年级",
          title: "举一反三",
          version: "人教版•2024秋",
        },
        {
          id: 3279469,
          grade: "二年级",
          title: "举一反三",
          version: "人教版",
        },
        {
          id: 3279468,
          grade: "三年级",
          title: "举一反三",
          version: "人教版",
        },
        {
          id: 3279467,
          grade: "四年级",
          title: "举一反三",
          version: "人教版",
        },
        {
          id: 3279466,
          grade: "五年级",
          title: "举一反三",
          version: "人教版",
        },
        {
          id: 3279465,
          grade: "六年级",
          title: "举一反三",
          version: "人教版",
        },
      ],
      errorsAndVariationsDataOneThird: [
        {
          id: 3338343,
          grade: "三年级",
          title: "典例精讲",
          version: "人教版",
        },
        {
          id: 3338342,
          grade: "四年级",
          title: "典例精讲",
          version: "人教版",
        },
        {
          id: 3338340,
          grade: "五年级",
          title: "典例精讲",
          version: "人教版",
        },
        {
          id: 3338339,
          grade: "六年级",
          title: "典例精讲",
          version: "人教版",
        },
      ],
      errorsAndVariationsDataOneFourth: [
        {
          id: 3299262,
          grade: "三年级",
          title: "典例例题系列",
          version: "人教版",
        },
        {
          id: 3299261,
          grade: "四年级",
          title: "典例例题系列",
          version: "人教版",
        },
        {
          id: 3299260,
          grade: "五年级",
          title: "典例例题系列",
          version: "人教版",
        },
        {
          id: 3299258,
          grade: "六年级",
          title: "典例例题系列",
          version: "人教版",
        },
      ],

      errorsAndVariationsDataTwo: [
        {
          id: 3275802,
          grade: "一年级",
          title: "小马虎错题本",
          version: "苏教版•2024秋",
        },
        {
          id: 3275488,
          grade: "二年级",
          title: "小马虎错题本",
          version: "苏教版",
        },
        {
          id: 3275487,
          grade: "三年级",
          title: "小马虎错题本",
          version: "苏教版",
        },
        {
          id: 3275486,
          grade: "四年级",
          title: "小马虎错题本",
          version: "苏教版",
        },
        {
          id: 3275485,
          grade: "五年级",
          title: "小马虎错题本",
          version: "苏教版",
        },
        {
          id: 3275484,
          grade: "六年级",
          title: "小马虎错题本",
          version: "苏教版",
        },
      ],
      errorsAndVariationsDataTwoFirst: [
        {
          id: 3275802,
          grade: "一年级",
          title: "小马虎错题本",
          version: "苏教版•2024秋",
        },
        {
          id: 3275488,
          grade: "二年级",
          title: "小马虎错题本",
          version: "苏教版",
        },
        {
          id: 3275487,
          grade: "三年级",
          title: "小马虎错题本",
          version: "苏教版",
        },
        {
          id: 3275486,
          grade: "四年级",
          title: "小马虎错题本",
          version: "苏教版",
        },
        {
          id: 3275485,
          grade: "五年级",
          title: "小马虎错题本",
          version: "苏教版",
        },
        {
          id: 3275484,
          grade: "六年级",
          title: "小马虎错题本",
          version: "苏教版",
        },
      ],
      errorsAndVariationsDataTwoSecond: [
        {
          id: 3279514,
          grade: "一年级",
          title: "举一反三",
          version: "苏教版•2024秋",
        },
        {
          id: 3279460,
          grade: "二年级",
          title: "举一反三",
          version: "苏教版",
        },
        {
          id: 3279504,
          grade: "三年级",
          title: "举一反三",
          version: "苏教版",
        },
        {
          id: 3279486,
          grade: "四年级",
          title: "举一反三",
          version: "苏教版",
        },
        {
          id: 3279483,
          grade: "五年级",
          title: "举一反三",
          version: "苏教版",
        },
        {
          id: 3279482,
          grade: "六年级",
          title: "举一反三",
          version: "苏教版",
        },
      ],
      errorsAndVariationsDataTwoThird: [
        {
          id: 3338336,
          grade: "三年级",
          title: "典例精讲",
          version: "苏教版",
        },
        {
          id: 3338332,
          grade: "四年级",
          title: "典例精讲",
          version: "苏教版",
        },
        {
          id: 3338331,
          grade: "五年级",
          title: "典例精讲",
          version: "苏教版",
        },
        {
          id: 3338330,
          grade: "六年级",
          title: "典例精讲",
          version: "苏教版",
        },
      ],
      errorsAndVariationsDataTwoFourth: [
        {
          id: 3302504,
          grade: "三年级",
          title: "典例例题系列",
          version: "苏教版",
        },
        {
          id: 3302503,
          grade: "四年级",
          title: "典例例题系列",
          version: "苏教版",
        },
        {
          id: 3302501,
          grade: "五年级",
          title: "典例例题系列",
          version: "苏教版",
        },
        {
          id: 3302500,
          grade: "六年级",
          title: "典例例题系列",
          version: "苏教版",
        },
      ],

      errorsAndVariationsDataThree: [
        {
          id: 3275801,
          grade: "一年级",
          title: "小马虎错题本",
          version: "北师大版•2024秋",
        },
        {
          id: 3275814,
          grade: "二年级",
          title: "小马虎错题本",
          version: "北师大版",
        },
        {
          id: 3275813,
          grade: "三年级",
          title: "小马虎错题本",
          version: "北师大版",
        },
        {
          id: 3275812,
          grade: "四年级",
          title: "小马虎错题本",
          version: "北师大版",
        },
        {
          id: 3275810,
          grade: "五年级",
          title: "小马虎错题本",
          version: "北师大版",
        },
        {
          id: 3275807,
          grade: "六年级",
          title: "小马虎错题本",
          version: "北师大版",
        },
      ],
      errorsAndVariationsDataThreeFirst: [
        {
          id: 3275801,
          grade: "一年级",
          title: "小马虎错题本",
          version: "北师大版•2024秋",
        },
        {
          id: 3275814,
          grade: "二年级",
          title: "小马虎错题本",
          version: "北师大版",
        },
        {
          id: 3275813,
          grade: "三年级",
          title: "小马虎错题本",
          version: "北师大版",
        },
        {
          id: 3275812,
          grade: "四年级",
          title: "小马虎错题本",
          version: "北师大版",
        },
        {
          id: 3275810,
          grade: "五年级",
          title: "小马虎错题本",
          version: "北师大版",
        },
        {
          id: 3275807,
          grade: "六年级",
          title: "小马虎错题本",
          version: "北师大版",
        },
      ],
      errorsAndVariationsDataThreeSecond: [
        {
          id: 3279513,
          grade: "一年级",
          title: "举一反三",
          version: "北师大版•2024秋",
        },
        {
          id: 3279503,
          grade: "二年级",
          title: "举一反三",
          version: "北师大版",
        },
        {
          id: 3279502,
          grade: "三年级",
          title: "举一反三",
          version: "北师大版",
        },
        {
          id: 3279501,
          grade: "四年级",
          title: "举一反三",
          version: "北师大版",
        },
        {
          id: 3279487,
          grade: "五年级",
          title: "举一反三",
          version: "北师大版",
        },
        {
          id: 3279510,
          grade: "六年级",
          title: "举一反三",
          version: "北师大版",
        },
      ],
      errorsAndVariationsDataThreeThird: [
        {
          id: 3338320,
          grade: "三年级",
          title: "典例精讲",
          version: "北师大版",
        },
        {
          id: 3338322,
          grade: "四年级",
          title: "典例精讲",
          version: "北师大版",
        },
        {
          id: 3338323,
          grade: "五年级",
          title: "典例精讲",
          version: "北师大版",
        },
        {
          id: 3338324,
          grade: "六年级",
          title: "典例精讲",
          version: "北师大版",
        },
      ],
      errorsAndVariationsDataThreeFourth: [
        {
          id: 3302511,
          grade: "三年级",
          title: "典例例题系列",
          version: "北师大版",
        },
        {
          id: 3302510,
          grade: "四年级",
          title: "典例例题系列",
          version: "北师大版",
        },
        {
          id: 3302509,
          grade: "五年级",
          title: "典例例题系列",
          version: "北师大版",
        },
        {
          id: 3302507,
          grade: "六年级",
          title: "典例例题系列",
          version: "北师大版",
        },
      ],

      mindExpansionTrainingDataOne: [
        {
          id: 46026744,
          title: "专题1 归一归总问题-小升初数学模块化思维拓展（通用版）",
        },
        {
          id: 46026752,
          title: "专题2 和差问题-小升初数学模块化思维拓展（通用版）",
        },
        {
          id: 46026748,
          title: "专题3 和倍问题-小升初数学模块化思维拓展（通用版）",
        },
        {
          id: 46026746,
          title: "专题4 差倍问题-小升初数学模块化思维拓展（通用版）",
        },
      ],
      mindExpansionTrainingDataTwo: [
        {
          id: 47120319,
          title: "第一单元时、分、秒·思维素养篇【从课内到奥数】",
        },
        {
          id: 47132056,
          title: "第二单元万以内的加法和减法·思维素养篇【从课内到奥数】",
        },
        { id: 47138941, title: "第三单元测量·思维素养篇【从课内到奥数】" },
        {
          id: 47156523,
          title: "第四单元万以内的加法和减法·思维素养篇【从课内到奥数】",
        },
      ],
      mindExpansionTrainingDataThree: [
        {
          id: 3252449,
          grade: "三年级",
          title: "思维拓展专项",
          version: "通用版",
        },
        {
          id: 3252448,
          grade: "四年级",
          title: "思维拓展专项",
          version: "通用版",
        },
        {
          id: 3252447,
          grade: "五年级",
          title: "思维拓展专项",
          version: "通用版",
        },
        {
          id: 3252446,
          grade: "六年级",
          title: "思维拓展专项",
          version: "通用版",
        },
      ],
      optimizingMovelengthOne: 0,
      optimizingMovelengthTwo: 0,
      optimizingMoveIndexOne: 1,
      optimizingMoveIndexTwo: 1,
    };
  },
  mounted() {
    window.addEventListener("scroll", this.onScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.onScroll);
  },
  methods: {
    toResourcePage(resourceId) {
      //新页面跳转
      window.open(`https://wxt.xkw.com/soft/${resourceId}-1.html`);
    },
    toAlbumPage(resourceId) {
      //新页面跳转
      window.open(`https://wxt.xkw.com/docpack/${resourceId}.html`);
    },
    changeVersion(version) {
      this.completeCalculationProblemVersion = version;
    },
    changeProblemVersion(version) {
      this.problemSolvingGuidanceVersion = version;
    },
    changeVariationsVersion(version) {
      this.optimizingMovelengthThree = 0;
      this.optimizingMovelengthFour = 0;
      this.optimizingMovelengthFive = 0;
      this.optimizingMoveIndexThree = 1;
      this.optimizingMoveIndexFour = 1;
      this.optimizingMoveIndexFive = 1;
      this.errorsAndVariationsVersion = version;
      if (version == 1) {
        this.errorsAndVariationsDataOne = this.errorsAndVariationsDataOneFirst;
        this.errorsAndVariationsDataTwo = this.errorsAndVariationsDataTwoFirst;
        this.errorsAndVariationsDataThree =
          this.errorsAndVariationsDataThreeFirst;
      } else if (version == 2) {
        this.errorsAndVariationsDataOne = this.errorsAndVariationsDataOneSecond;
        this.errorsAndVariationsDataTwo = this.errorsAndVariationsDataTwoSecond;
        this.errorsAndVariationsDataThree =
          this.errorsAndVariationsDataThreeSecond;
      } else if (version == 3) {
        this.errorsAndVariationsDataOne = this.errorsAndVariationsDataOneThird;
        this.errorsAndVariationsDataTwo = this.errorsAndVariationsDataTwoThird;
        this.errorsAndVariationsDataThree =
          this.errorsAndVariationsDataThreeThird;
      } else {
        this.errorsAndVariationsDataOne = this.errorsAndVariationsDataOneFourth;
        this.errorsAndVariationsDataTwo = this.errorsAndVariationsDataTwoFourth;
        this.errorsAndVariationsDataThree =
          this.errorsAndVariationsDataThreeFourth;
      }
    },
    changeSide(id) {
      this.checkSideId = id;
    },
    onScroll() {
      const sections = [
        { id: 1, offset: document.querySelector("#div1").offsetTop },
        { id: 2, offset: document.querySelector("#div2").offsetTop },
        { id: 3, offset: document.querySelector("#div3").offsetTop },
        { id: 4, offset: document.querySelector("#div4").offsetTop },
        { id: 5, offset: document.querySelector("#div5").offsetTop },
        { id: 6, offset: document.querySelector("#div6").offsetTop },
      ];

      const scrollPosition = window.scrollY + window.innerHeight / 2;

      for (let i = sections.length - 1; i >= 0; i--) {
        if (scrollPosition >= sections[i].offset) {
          this.checkSideId = sections[i].id;
          break;
        }
      }
    },
    moveTranBody(arrow) {
      //左箭头
      if (arrow == 1) {
        if (this.optimizingMoveIndexOne == 1) {
          return;
        }
        this.optimizingMovelengthOne = this.optimizingMovelengthOne + 196;
        this.optimizingMoveIndexOne--;
      }
      //右箭头
      else {
        if (this.optimizingMoveIndexOne == 3) {
          return;
        }
        this.optimizingMovelengthOne = this.optimizingMovelengthOne - 196;
        this.optimizingMoveIndexOne++;
      }
    },
    moveTranBodyTwo(arrow) {
      //左箭头
      if (arrow == 1) {
        if (this.optimizingMoveIndexTwo == 1) {
          return;
        }
        this.optimizingMovelengthTwo = this.optimizingMovelengthTwo + 196;
        this.optimizingMoveIndexTwo--;
      }
      //右箭头
      else {
        if (this.optimizingMoveIndexTwo == 3) {
          return;
        }
        this.optimizingMovelengthTwo = this.optimizingMovelengthTwo - 196;
        this.optimizingMoveIndexTwo++;
      }
    },
    moveTranBodyThree(arrow) {
      //左箭头
      if (arrow == 1) {
        if (this.optimizingMoveIndexThree == 1) {
          return;
        }
        this.optimizingMovelengthThree = this.optimizingMovelengthThree + 196;
        this.optimizingMoveIndexThree--;
      }
      //右箭头
      else {
        if (this.optimizingMoveIndexThree == 3) {
          return;
        }
        this.optimizingMovelengthThree = this.optimizingMovelengthThree - 196;
        this.optimizingMoveIndexThree++;
      }
    },
    moveTranBodyFour(arrow) {
      //左箭头
      if (arrow == 1) {
        if (this.optimizingMoveIndexFour == 1) {
          return;
        }
        this.optimizingMovelengthFour = this.optimizingMovelengthFour + 196;
        this.optimizingMoveIndexFour--;
      }
      //右箭头
      else {
        if (this.optimizingMoveIndexFour == 3) {
          return;
        }
        this.optimizingMovelengthFour = this.optimizingMovelengthFour - 196;
        this.optimizingMoveIndexFour++;
      }
    },
    moveTranBodyFive(arrow) {
      //左箭头
      if (arrow == 1) {
        if (this.optimizingMoveIndexFive == 1) {
          return;
        }
        this.optimizingMovelengthFive = this.optimizingMovelengthFive + 196;
        this.optimizingMoveIndexFive--;
      }
      //右箭头
      else {
        if (this.optimizingMoveIndexFive == 3) {
          return;
        }
        this.optimizingMovelengthFive = this.optimizingMovelengthFive - 196;
        this.optimizingMoveIndexFive++;
      }
    },
  },
};
</script>
<style scoped lang="scss">
.primary-feature {
  background: #fbf0d0;
}

.head {
  //position: relative;
  //height: 380px;
  //width: 100%;

  .head-banner {
    width: 100%;
    height: 100%;
  }
}

.complete-calculation-problem {
  width: 100%;
  background: #fbf0d0;
  height: 840px;

  .introduce {
    width: 1200px;
    height: 150px;
    border-radius: 20px;
    border: 1px solid #fbf0cf;
    background: #fffefc;
    position: relative;
    margin: 0px auto;

    .introduce-title {
      position: relative;
      color: #0568ff;
      text-align: center;
      font-family: "PingFang SC";
      font-size: 20px;
      font-style: normal;
      font-weight: 600;
      line-height: 27px; /* 135% */
      width: 340px;
      height: 42px;
      margin: 0px auto;
    }

    .content {
      color: #000;
      text-align: center;
      font-family: "PingFang SC";
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 27px; /* 168.75% */
      margin: 23px auto 0px;
      width: 1008px;
      height: 54px;
    }
  }

  .start {
    text-align: center;
    margin-top: 34px;

    .title {
      font-family: "PingFang SC";
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 27px; /* 168.75% */
      color: #000;
    }
  }

  .title {
    width: 314px;
    height: 36px;
    flex-shrink: 0;
    margin: 50px auto 0px;
    text-align: center;

    .main-title {
      color: #0366ff;
      font-family: "PingFang SC";
      font-size: 36px;
      font-style: normal;
      font-weight: 600;
      line-height: 36px; /* 100% */
    }
  }

  .resource-list {
    width: 1200px;
    height: 431px;
    border-radius: 20px;
    border: 1px solid #ffd656;
    background: #fff;
    margin: 30px auto 60px;

    .tabs {
      margin: 30px auto 35px;
      height: 42px;
      width: 572px;

      div {
        width: 184px;
        height: 42px;

        display: inline-block;
        border-radius: 8px;

        text-align: center;
        font-family: "PingFang SC";
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 42px; /* 225% */
      }
    }

    .dataTwo {
      margin-left: 42px;
      margin-top: 38px;
      height: 260px;
      width: 1120px;

      .left {
        width: 204px;
        height: 260px;
        position: relative;
        display: inline-block;

        .title {
          color: #fb5b1f;
          font-family: "PingFang SC";
          font-size: 22px;
          font-style: normal;
          font-weight: 600;
          line-height: 24px; /* 109.091% */

          position: absolute;
          bottom: 168px;
          left: -60px;
        }

        .describe {
          color: #fff;
          font-family: "PingFang SC";
          font-size: 14px;
          font-style: normal;
          font-weight: 400;
          line-height: 21px; /* 150% */

          position: absolute;
          bottom: 70px;
          left: 37px;
        }
        .see-all {
          width: 102px;
          height: 34px;
          border-radius: 30px;
          background: #feffbe;
          box-shadow: 0px 2px 0px 0px #0669ff;

          color: #fb5b1f;
          text-align: center;
          font-family: "PingFang SC";
          font-size: 16px;
          font-style: normal;
          font-weight: 600;
          line-height: 34px; /* 125% */

          position: absolute;
          bottom: 32px;
          left: 64px;

          &:hover {
            cursor: pointer;
            background: #fb5b1f;
            color: #feffbe;
          }
        }
      }

      .right {
        padding-left: 16px;
        width: 910px;
        height: 260px;
        background: #fbf9d9;
        display: inline-block;

        .resource {
          margin-left: 15px;
          margin-top: 43px;
          display: inline-block;
          position: relative;
          transition: all 0.3s;

          .grade {
            color: #fff;
            text-align: center;
            font-family: "PingFang SC";
            font-size: 14px;
            font-style: normal;
            font-weight: 500;
            line-height: 13.057px; /* 93.261% */

            position: absolute;
            bottom: 163px;
            left: 43px;
          }
          .title {
            color: #a23d04;
            font-family: "PingFang SC";
            font-size: 16px;
            font-style: normal;
            font-weight: 600;
            line-height: 19.585px; /* 122.405% */

            position: absolute;
            bottom: 109px;
            left: -92px;
          }
          .version {
            color: #a23d04;
            font-family: "Alibaba PuHuiTi 3.0";
            font-size: 12px;
            font-style: normal;
            font-weight: 400;
            line-height: 19.585px; /* 163.207% */

            position: absolute;
            bottom: 101px;
            left: 47px;
          }
          .see-all {
            text-align: center;
            width: 90px;
            height: 21.881px;
            border-radius: 30px;
            background: #feffbe;
            color: #000;
            font-family: "Alibaba PuHuiTi";
            font-size: 12px;
            font-style: normal;
            font-weight: 400;
            line-height: 21.881px; /* 136.006% */
            position: absolute;
            bottom: 36px;
            left: 19px;
          }

          &:hover {
            cursor: pointer;
            transform: translateY(-10px);
          }
        }
      }
    }
  }
}

.problem-solving-guidance {
  width: 100%;
  background: #ffebb0;
  height: 615px;
  padding-top: 60px;

  .title {
    width: 314px;
    height: 36px;
    flex-shrink: 0;
    margin: 0px auto;
    text-align: center;

    .main-title {
      color: #0366ff;
      font-family: "PingFang SC";
      font-size: 36px;
      font-style: normal;
      font-weight: 600;
      line-height: 36px; /* 100% */
    }
  }

  .resource-list {
    width: 1200px;
    height: 430px;
    border-radius: 20px;
    border: 1px solid #ffd656;
    background: #fff;
    margin: 30px auto 60px;

    .tabs {
      margin: 30px auto 35px;
      height: 42px;
      width: 572px;

      div {
        width: 184px;
        height: 42px;
        display: inline-block;
        border-radius: 8px;

        text-align: center;
        font-family: "PingFang SC";
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 42px; /* 225% */
      }
    }

    .dataTwo {
      margin-left: 42px;
      margin-top: 38px;
      height: 260px;
      width: 1120px;

      .left {
        width: 204px;
        height: 260px;
        position: relative;
        display: inline-block;

        .title {
          color: #fb5b1f;
          font-family: "PingFang SC";
          font-size: 19px;
          font-style: normal;
          font-weight: 600;
          line-height: 24px; /* 109.091% */

          position: absolute;
          bottom: 168px;
          left: -60px;
        }

        .describe {
          color: #fff;
          font-family: "PingFang SC";
          font-size: 14px;
          font-style: normal;
          font-weight: 400;
          line-height: 21px; /* 150% */

          position: absolute;
          bottom: 70px;
          left: 37px;
        }
        .see-all {
          width: 102px;
          height: 34px;
          border-radius: 30px;
          background: #feffbe;
          box-shadow: 0px 2px 0px 0px #0669ff;

          color: #fb5b1f;
          text-align: center;
          font-family: "PingFang SC";
          font-size: 16px;
          font-style: normal;
          font-weight: 600;
          line-height: 34px; /* 125% */

          position: absolute;
          bottom: 32px;
          left: 64px;

          &:hover {
            cursor: pointer;
            background: #fb5b1f;
            color: #feffbe;
          }
        }
      }

      .right {
        padding-left: 16px;
        width: 910px;
        height: 260px;
        background: #fbf9d9;
        display: inline-block;

        .resource {
          margin-left: 64px;
          margin-top: 43px;
          display: inline-block;
          position: relative;
          transition: all 0.3s;

          .grade {
            color: #fff;
            text-align: center;
            font-family: "PingFang SC";
            font-size: 14px;
            font-style: normal;
            font-weight: 500;
            line-height: 13.057px; /* 93.261% */

            position: absolute;
            bottom: 163px;
            left: 43px;
          }
          .title {
            color: #0072ff;
            font-family: "PingFang SC";
            font-size: 16px;
            font-style: normal;
            font-weight: 600;
            line-height: 19.585px; /* 122.405% */
            position: absolute;
            bottom: 109px;
            left: -92px;
          }
          .version {
            color: #0072ff;
            font-family: "Alibaba PuHuiTi 3.0";
            font-size: 12px;
            font-style: normal;
            font-weight: 400;
            line-height: 19.585px; /* 163.207% */
            position: absolute;
            bottom: 101px;
            left: 47px;
          }
          .see-all {
            text-align: center;
            width: 90px;
            height: 21.881px;
            border-radius: 30px;
            background: #e2ffff;
            color: #000;
            font-family: "Alibaba PuHuiTi";
            font-size: 12px;
            font-style: normal;
            font-weight: 400;
            line-height: 21.881px; /* 136.006% */
            position: absolute;
            bottom: 36px;
            left: 19px;
          }

          &:hover {
            cursor: pointer;
            transform: translateY(-10px);
          }
        }
      }
    }
  }
}

.errors-and-variations {
  width: 100%;
  height: 1203px;
  background: #fbf0d0;
  padding-top: 60px;

  .title {
    width: 314px;
    height: 36px;
    flex-shrink: 0;
    margin: 0px auto;
    text-align: center;

    .main-title {
      color: #0366ff;
      font-family: "PingFang SC";
      font-size: 36px;
      font-style: normal;
      font-weight: 600;
      line-height: 36px; /* 100% */
    }
  }

  .resource-list {
    width: 1200px;
    height: 1017px;
    border-radius: 20px;
    border: 1px solid #ffd656;
    background: #fff;
    margin: 30px auto 60px;

    .tabs {
      margin: 32px auto 17px;
      height: 42px;
      width: 770px;

      div {
        width: 184px;
        height: 42px;
        display: inline-block;
        border-radius: 8px;

        text-align: center;
        font-family: "PingFang SC";
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 42px; /* 225% */
      }
    }

    .subtitle {
      color: #767676;
      text-align: justify;
      font-family: "PingFang SC";
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: 21px; /* 175% */

      height: 21px;
      width: 470px;
      margin: 0px auto 17px;
    }

    .data {
      margin-left: 42px;
      height: 260px;
      width: 1120px;

      .left {
        width: 204px;
        height: 260px;
        display: inline-block;
      }

      .right {
        padding-left: 16px;
        width: 910px;
        height: 260px;
        background: #fbf9d9;
        display: inline-block;
        position: relative;

        .left-arrow {
          display: inline-block;
          position: absolute;
          left: 30px;
          top: 100px;
          cursor: pointer;

          &:hover {
            circle {
              fill: #a19df0;
            }
            path {
              fill: white;
            }
          }
        }
        .left-arrow-disable {
          display: inline-block;
          position: absolute;
          left: 30px;
          top: 100px;
          opacity: 0.35;
        }

        .show-range {
          display: inline-block;
          width: 720px;
          position: absolute;
          left: 100px;
          overflow: hidden;

          .tran-body {
            width: 1195px;
            height: 260px;
            transition: all 0.3s;
            padding-top: 43px;
            position: relative;
            right: 64px;

            .resource {
              margin-left: 64px;
              display: inline-block;
              position: relative;
              transition: all 0.3s;
              &:hover {
                cursor: pointer;
                transform: translateY(-10px);
              }
              .grade {
                color: #fff;
                text-align: center;
                font-family: "PingFang SC";
                font-size: 14px;
                font-style: normal;
                font-weight: 500;
                line-height: 13.057px; /* 93.261% */
                position: absolute;
                bottom: 163px;
                left: 43px;
              }
              .title {
                color: #4d3ff3;
                font-family: "PingFang SC";
                font-size: 16px;
                font-style: normal;
                font-weight: 600;
                line-height: 19.585px; /* 122.405% */
                position: absolute;
                bottom: 109px;
                left: -92px;
              }
              .version {
                color: #4d3ff3;
                font-family: "Alibaba PuHuiTi 3.0";
                font-size: 12px;
                font-style: normal;
                font-weight: 300;
                line-height: 19.585px; /* 163.207% */
                position: absolute;
                bottom: 101px;
                text-align: center;
                width: 132px;
              }
              .see-all {
                text-align: center;
                width: 90px;
                height: 21.881px;
                border-radius: 30px;
                background: #ebe9ff;
                color: #000;
                font-family: "Alibaba PuHuiTi";
                font-size: 12px;
                font-style: normal;
                font-weight: 400;
                line-height: 21.881px; /* 136.006% */
                position: absolute;
                bottom: 36px;
                left: 19px;
              }
            }
          }
        }

        .right-arrow {
          display: inline-block;
          position: absolute;
          right: 30px;
          top: 100px;
          cursor: pointer;

          &:hover {
            circle {
              fill: #a19df0;
            }
            path {
              fill: white;
            }
          }
        }

        .right-arrow-disable {
          display: inline-block;
          position: absolute;
          right: 30px;
          top: 100px;
          opacity: 0.35;
        }
      }
    }
  }
}

.optimizing-ideological-methods {
  width: 100%;
  height: 830px;
  background: #ffebb0;
  padding-top: 60px;

  .title {
    width: 314px;
    height: 36px;
    flex-shrink: 0;
    margin: 0px auto;
    text-align: center;

    .main-title {
      color: #0366ff;
      font-family: "PingFang SC";
      font-size: 36px;
      font-style: normal;
      font-weight: 600;
      line-height: 36px; /* 100% */
    }
  }

  .resource-list {
    width: 1200px;
    height: 644px;
    border-radius: 20px;
    border: 1px solid #ffd656;
    background: #fff;
    margin: 30px auto 60px;

    .data {
      margin-left: 42px;
      margin-top: 38px;
      height: 260px;
      width: 1120px;

      .left {
        width: 204px;
        height: 260px;
        position: relative;
        display: inline-block;

        .title {
          color: #fb5b1f;
          font-family: "PingFang SC";
          font-size: 22px;
          font-style: normal;
          font-weight: 600;
          line-height: 24px; /* 109.091% */

          position: absolute;
          bottom: 168px;
          left: -60px;
        }

        .describe {
          color: #fff;
          font-family: "PingFang SC";
          font-size: 14px;
          font-style: normal;
          font-weight: 400;
          line-height: 21px; /* 150% */

          position: absolute;
          bottom: 84px;
          left: 37px;
        }
        .see-all {
          width: 102px;
          height: 34px;
          border-radius: 30px;
          background: #feffbe;
          box-shadow: 0px 2px 0px 0px #0669ff;

          color: #fb5b1f;
          text-align: center;
          font-family: "PingFang SC";
          font-size: 16px;
          font-style: normal;
          font-weight: 600;
          line-height: 34px; /* 125% */

          position: absolute;
          bottom: 32px;
          left: 64px;

          &:hover {
            cursor: pointer;
            background: #fb5b1f;
            color: #feffbe;
          }
        }
      }

      .right {
        padding-left: 16px;
        width: 910px;
        height: 260px;
        background: #fbf9d9;
        display: inline-block;
        position: relative;

        .left-arrow {
          display: inline-block;
          position: absolute;
          left: 30px;
          top: 100px;
          cursor: pointer;

          &:hover {
            circle {
              fill: #fdbf1e;
            }
            path {
              fill: white;
            }
          }
        }
        .left-arrow-disable {
          display: inline-block;
          position: absolute;
          left: 30px;
          top: 100px;
          opacity: 0.35;
        }

        .show-range {
          display: inline-block;
          width: 720px;
          position: absolute;
          left: 100px;
          overflow: hidden;

          .tran-body {
            width: 1195px;
            height: 260px;
            transition: all 0.3s;
            padding-top: 43px;
            position: relative;
            right: 64px;

            .resource {
              display: inline-block;
              position: relative;
              margin-left: 64px;
              transition: all 0.3s;

              .grade {
                color: #fff;
                text-align: center;
                font-family: "PingFang SC";
                font-size: 14px;
                font-style: normal;
                font-weight: 500;
                line-height: 13.057px; /* 93.261% */

                position: absolute;
                bottom: 163px;
                left: 43px;
              }
              .title {
                color: #a23d04;
                font-family: "PingFang SC";
                font-size: 16px;
                font-style: normal;
                font-weight: 600;
                line-height: 19.585px; /* 122.405% */
                position: absolute;
                bottom: 109px;
                left: -92px;
              }
              .version {
                color: #a23d04;
                font-family: "Alibaba PuHuiTi 3.0";
                font-size: 12px;
                font-style: normal;
                font-weight: 400;
                line-height: 19.585px; /* 163.207% */
                position: absolute;
                bottom: 101px;
                text-align: center;
                width: 132px;
              }
              .see-all {
                text-align: center;
                width: 90px;
                height: 21.881px;
                border-radius: 30px;
                background: #feffbe;
                color: #000;
                font-family: "Alibaba PuHuiTi";
                font-size: 12px;
                font-style: normal;
                font-weight: 400;
                line-height: 21.881px; /* 136.006% */
                position: absolute;
                bottom: 36px;
                left: 19px;
              }

              &:hover {
                cursor: pointer;
                transform: translateY(-10px);
              }
            }
          }
        }

        .right-arrow {
          display: inline-block;
          position: absolute;
          right: 30px;
          top: 100px;
          cursor: pointer;

          &:hover {
            circle {
              fill: #fdbf1e;
            }
            path {
              fill: white;
            }
          }
        }

        .right-arrow-disable {
          display: inline-block;
          position: absolute;
          right: 30px;
          top: 100px;
          opacity: 0.35;
        }
      }
    }
  }
}

.mind-expansion-training {
  width: 100%;
  height: 1122px;
  background: #fbf0d0;
  padding-top: 60px;

  .title {
    width: 314px;
    height: 36px;
    flex-shrink: 0;
    margin: 0px auto;
    text-align: center;

    .main-title {
      color: #0366ff;
      font-family: "PingFang SC";
      font-size: 36px;
      font-style: normal;
      font-weight: 600;
      line-height: 36px; /* 100% */
    }
  }

  .resource-list {
    width: 1200px;
    height: 936px;
    border-radius: 20px;
    border: 1px solid #ffd656;
    background: #fff;
    margin: 30px auto 60px;

    .data {
      margin-left: 42px;
      margin-top: 38px;
      height: 260px;
      width: 1120px;

      .left {
        width: 204px;
        height: 260px;
        position: relative;
        display: inline-block;

        .title {
          color: #fb5b1f;
          font-family: "PingFang SC";
          font-size: 18px;
          font-style: normal;
          font-weight: 600;
          line-height: 24px; /* 109.091% */

          position: absolute;
          bottom: 167px;
          left: -60px;
        }

        .describe {
          color: #fff;
          font-family: "PingFang SC";
          font-size: 14px;
          font-style: normal;
          font-weight: 400;
          line-height: 21px; /* 150% */

          position: absolute;
          bottom: 84px;
          left: 37px;
        }
        .see-all {
          width: 102px;
          height: 34px;
          border-radius: 30px;
          background: #feffbe;
          box-shadow: 0px 2px 0px 0px #0669ff;

          color: #fb5b1f;
          text-align: center;
          font-family: "PingFang SC";
          font-size: 16px;
          font-style: normal;
          font-weight: 600;
          line-height: 34px; /* 125% */

          position: absolute;
          bottom: 32px;
          left: 64px;

          &:hover {
            cursor: pointer;
            background: #fb5b1f;
            color: #feffbe;
          }
        }
      }

      .right {
        width: 910px;
        height: 260px;
        background: #fbf9d9;
        display: inline-block;
        padding-top: 24px;

        .resource {
          height: 21px;
          width: 724px;
          margin-top: 20px;
          margin-left: 68px;

          .title {
            display: inline-block;
            height: 21px;
            width: 640px;
            color: #1e1e1e;
            text-align: justify;
            font-family: "PingFang SC";
            font-size: 18px;
            font-style: normal;
            font-weight: 400;
            line-height: 21px; /* 116.667% */

            &:hover {
              color: #0072ff;
              cursor: pointer;
            }
          }
          .see-info {
            display: inline-block;
            width: 77px;
            height: 22px;
            border-radius: 8px;
            background: #e8f3fd;
            border: #0072ff solid 1px;

            color: #0072ff;
            text-align: center;
            font-family: "PingFang TC";
            font-size: 16px;
            font-style: normal;
            font-weight: 500;
            line-height: 20px; /* 125% */

            &:hover {
              background: #0072ff;
              color: #e8f3fd;
              cursor: pointer;
            }
          }
        }

        .see-all {
          color: #0072ff;
          text-align: center;
          font-family: "PingFang SC";
          font-size: 16px;
          font-style: normal;
          font-weight: 600;
          line-height: 36px; /* 225% */
          width: 96px;
          height: 36px;
          margin: 18px auto 0px;
          position: relative;
          right: 50px;

          &:hover {
            cursor: pointer;
          }
        }

        .img-resource {
          margin-left: 80px;
          margin-top: 20px;
          display: inline-block;
          position: relative;
          transition: all 0.3s;

          .grade {
            color: #fff;
            text-align: center;
            font-family: "PingFang SC";
            font-size: 14px;
            font-style: normal;
            font-weight: 500;
            line-height: 13.057px; /* 93.261% */

            position: absolute;
            bottom: 163px;
            left: 43px;
          }
          .title {
            color: #004fc6;
            font-family: "Alibaba PuHuiTi 3.0";
            font-size: 16px;
            font-style: normal;
            font-weight: 700;
            line-height: 19.585px; /* 122.405% */
            position: absolute;
            bottom: 109px;
            left: -92px;
          }
          .version {
            color: #004fc6;
            font-family: "Alibaba PuHuiTi 3.0";
            font-size: 12px;
            font-style: normal;
            font-weight: 400;
            line-height: 19.585px; /* 163.207% */
            position: absolute;
            bottom: 101px;
            left: 47px;
          }
          .see-all {
            text-align: center;
            width: 90px;
            height: 21.881px;
            border-radius: 30px;
            background: #fef5a4;
            color: #000;
            font-family: "Alibaba PuHuiTi";
            font-size: 12px;
            font-style: normal;
            font-weight: 400;
            line-height: 21.881px; /* 136.006% */
            position: absolute;
            bottom: 36px;
            left: 19px;
          }

          &:hover {
            cursor: pointer;
            transform: translateY(-10px);
          }
        }
      }
    }
  }
}

.fun-math-paradise {
  width: 100%;
  height: 565px;
  background: #ffebb0;
  padding-top: 60px;

  .title {
    width: 314px;
    height: 36px;
    flex-shrink: 0;
    margin: 0px auto;
    text-align: center;

    .main-title {
      color: #0366ff;
      font-family: "PingFang SC";
      font-size: 36px;
      font-style: normal;
      font-weight: 600;
      line-height: 36px; /* 100% */
    }
  }

  .resource-list {
    width: 1200px;
    height: 379px;
    border-radius: 20px;
    border: 1px solid #ffd656;
    background: #fff;
    margin: 30px auto 60px;

    .img-list {
      width: 1119px;
      height: 296px;
      background: #fbf9d9;
      border-radius: 30px;
      margin-left: 42px;
      margin-top: 42px;

      .resource {
        margin-left: 58px;
        margin-top: 36px;
        display: inline-block;
        text-align: center;
        transition: all 0.3s;

        .describe {
          color: #000;
          font-family: "Alibaba PuHuiTi";
          font-size: 12px;
          font-style: normal;
          font-weight: 400;
          line-height: 19.585px; /* 163.207% */
          opacity: 0.5;
        }

        &:hover {
          cursor: pointer;
          transform: translateY(-10px);
        }
      }
    }
  }
}

.checked {
  background: #0568ff;
  color: #fff;

  &:hover {
    cursor: pointer;
    background: #94cefa;
  }
}

.unchecked {
  background: #b8dfff;
  color: #000;
  &:hover {
    cursor: pointer;
    background: #94cefa;
  }
}

.side {
  position: fixed;
  right: 10px;
  top: 40%;

  div {
    width: 106px;
    height: 28px;
    text-align: center;
    left: 1px;
    color: #fff;
    font-family: "PingFang SC";
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 28px; /* 100% */
    position: absolute;
    cursor: pointer;

    &:hover {
      color: #a6ecff;
    }
  }

  .title-1 {
    bottom: 195px;
  }
  .title-2 {
    bottom: 165px;
  }
  .title-3 {
    bottom: 135px;
  }
  .title-4 {
    bottom: 105px;
  }
  .title-5 {
    bottom: 75px;
  }
  .title-6 {
    bottom: 45px;
  }
  .back {
    position: absolute;
    bottom: 15px;
    left: 13px;
    cursor: pointer;
  }

  .side-checked {
    background: #035de9;

    color: #fff;
    font-family: "PingFang SC";
    font-size: 14px;
    font-style: normal;
    font-weight: 600;

    &:hover {
      color: #fff;
    }
  }
}
</style>
